module.exports = function () {
  return Array.from.apply(Array, arguments);
}
